(function () {
  'use strict';

  angular
    .module('web2print.recipients')
    .directive('addressForm', addressForm);

  /* @ngInject */
  function addressForm () {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/recipients/address-form.directive.html',
      scope: {
        receiver: '=',
        isSubmitted: '=',
        isPrevious: '=',
        isNew: '=',
        isOwn: '=',
        doneAddresses: '='
      },
      link: linkFunc,
      controller: AddressFormController,
      controllerAs: 'addressForm',
      bindToController: true
    };

    function linkFunc (scope, element, attrs) {
      scope.name = attrs.name;
    }

    return directive;
  }

  AddressFormController.$inject = ['$http', '$mdDialog', '$translate', 'FileDownload', 'FileUpload',
    'Upload', 'Common', 'addRecipientsValidationFactory', 'sidebarMyOrderFactory', '$state', 'recipientsFactory', '$scope',
    'productsFactory', 'webSocketFactory'
  ];

  /* @ngInject */
  function AddressFormController ($http, $mdDialog, $translate, FileDownload, FileUpload,
    Upload, Common, addRecipientsValidationFactory, sidebarMyOrderFactory, $state, recipientsFactory, $scope,
    productsFactory, webSocketFactory) {
    const vm = this;
    //  put here addressLimit
    const addressLimit = recipientsFactory.addressLimit;
    const overAllAddressLimit = recipientsFactory.overAllAddressLimit;

    function activate () {
      vm.downloadExampleFile = downloadExampleFile;
      vm.uploadSingle = uploadSingle;
      vm.removeAttachment = removeAttachment;
      vm.truncateFileName = truncateFileName;
      vm.resetRecipientModel = resetRecipientModel;
      vm.checkValidity = addRecipientsValidationFactory.validate;
      vm.resetFields = resetFields;
      vm.resetAll = resetAll;
      vm.cancelAdd = cancelAdd;
      vm.downloadInvalidAddressDetails = downloadInvalidAddressDetails;
      vm.getAddingAddressesStatus = getAddingAddressesStatus;
      vm.checkValidAddressCount = checkValidAddressCount;
      vm.checkInvalidAddressCount = checkInvalidAddressCount;
      vm.getFile = getFile;

      vm.file = Common.get('recipients.file', recipientsFactory.getAddressFile());
      recipientsFactory.setValidAddressCount(Common.get('recipients.validAddressCount', 0));
      recipientsFactory.setInvalidAddressCount(Common.get('recipients.invalidAddressCount', 0));
      vm.csvFolder = Common.get('recipients.csvFolder', null);
      vm.folderId = Common.get('addressesFolderId', null);
      vm.validColumns = Common.get('validColumns', true);
      vm.doneValidating = vm.invalidAddressCount;
      vm.zoneCount = Common.get('recipients.zoneCount', {});
      vm.totalAddress = Common.get('recipients.totalAddress', null);

      vm.showZoneCount = false;

      vm.readingFile = false;
      vm.showAddForm = false;
      vm.invalidFile = false;
      vm.downloading = false;
      vm.overLimit = false;
      vm.limitObject = { limit: getAddressLimits('max') };

      vm.maxRetry = 50;
      vm.retryCount = 1;
      vm.checkAddressValidityTimeout = 1000; //15000;

      vm.addressUploading = 'not_start';
      vm.addressStatus = 'not_start';

      vm.resetAll = resetAll;
      vm.getAddressLimits = getAddressLimits;
      vm.language = pnTopbar.language;
      vm.marketSE = pnTopbar.market === 'SE';
      vm.marketDK = pnTopbar.market === 'DK';
      vm.addressLimit = addressLimit;
      vm.overAllAddressLimit = overAllAddressLimit;
      vm.getNameSampleValue = getNameSampleValue;

      vm.recipientTypeObj = {
        'private': 'PRIVATE',
        'company': 'COMPANY'
      };

      vm.processing = sidebarMyOrderFactory.addressProcessing;

      if (!sidebarMyOrderFactory.addressProcessing) {
        recipientsFactory.setAddingAddresses(Common.get('recipients.validAddressCount') ? 'done' : 'not_start');
      } else {
        vm.doneAddresses = true;
      }

      if (!parseInt(recipientsFactory.getValidAddressCount())
        && !parseInt(recipientsFactory.getInvalidAddressCount())) {
        vm.invalidFileFormat = true;
      }


      Common.registerObserver('updateAddresses', setToSessionStorage);
      Common.registerObserver('removeAttatchment', removeAttachment);

      getSampleColumns();
      checkZoneCount();

      $scope.$on('changeLanguage', function (events, language) {
        console.log('Changing language');
        vm.language = language;
      });
    }

    function getFile () {
      return Common.get('recipients.file', recipientsFactory.getAddressFile());
    }

    function getAddingAddressesStatus () {
      return recipientsFactory.checkAddingAddresses();
    }

    function checkInvalidAddressCount () {
      return recipientsFactory.getInvalidAddressCount();
    }

    function checkValidAddressCount () {
      return recipientsFactory.getValidAddressCount();
    }

    function getAddressLimits (key) {
      const limit = key === 'min' ? addressLimit().min : addressLimit().max;

      return Common.formatNumber(limit);
    }

    function checkZoneCount () {
      if ((vm.zoneCount[1] || vm.zoneCount[2] || vm.zoneCount[3])) {
        vm.showZoneCount = true;
      }
    }

    function getSampleColumns () {
      const serviceType = Common.get('serviceType', 'information');
      recipientsFactory.getSampleColumns(serviceType)
        .then(function (res) {
          vm.sampleColumns = res.result;
        }, function (err) {
          console.log(err);
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function setToSessionStorage () {
      Common.set('recipients.file', recipientsFactory.getAddressFile());
      Common.set('pristine', false);
      Common.set('recipients.validAddressCount', angular.copy(recipientsFactory.getValidAddressCount()));
      Common.set('recipients.invalidAddressCount', angular.copy(recipientsFactory.getInvalidAddressCount()));
      Common.set('recipients.discountPostalCodeCount', angular.copy(vm.discountPostalCodeCount));
      Common.set('recipients.zoneCount', angular.copy(vm.zoneCount));
      Common.set('recipients.countryCodes', angular.copy(vm.countryCodes));
      Common.set('address', angular.copy(vm.csvFolder + '/' + 'validAddresses.txt'));
      Common.set('recipients.csvFolder', angular.copy(vm.csvFolder));
      Common.set('addressesFolderId', vm.folderId);
      Common.set('originalAddressFileName', recipientsFactory.getAddressFile());
      Common.set('validColumns', vm.validColumns);
      Common.set('uploadDateTime.addresses', moment());
      sidebarMyOrderFactory.setSidebarModel('recipients', recipientsFactory.getValidAddressCount());
      Common.notifyObserver('updateValidAddresses');
      Common.notifyObserver('web2print.pricing');
    }

    function downloadExampleFile () {
      FileDownload.getExampleFile();
    }

    function checkRecipients (wb, file, invalidFile) {
      const key = Object.keys(wb)[0];
      const serviceType = Common.get('serviceType', 'information');

      if ((wb[key].length > addressLimit().max) && serviceType !== 'admail') {
        vm.overLimit = true;
        recipientsFactory.setAddingAddresses('not_start');
        sidebarMyOrderFactory.addressProcessing = false;
        vm.addressUploading = 'not_start';
        vm.readingFile = false;
        vm.doneValidating = true;
        vm.invalidFile = false;
        vm.processing = false;
        $scope.$digest();
        return;
      }

      vm.invalidFileFormat = false;

      console.log('file: ' + file + ', invalidFile: ' + invalidFile);

      recipientsFactory.setAddressFile(file.name);
      recipientsFactory.setValidAddressCount(0);
      recipientsFactory.setInvalidAddressCount(0);

      const fileNameSplit = file.name.split('.');
      const fileType = fileNameSplit[fileNameSplit.length - 1];
      const newFile = Upload.rename(file, 'uploadedAddress.' + fileType);
      const meta = {
        service: serviceType,
        originalFileName: file.name
      };

      FileUpload.uploadSingleFile(newFile, 'csv', 'uploadedAddress.' + fileType, meta)
        .success(function (response) {
          uploadToS3(newFile, response);
        });
    }

    function uploadSingle (file, invalidFile) {
      if (invalidFile || !file) {
        vm.invalidFile = true;
        return;
      }

      vm.overLimit = false;
      vm.doneValidating = false;
      vm.invalidFile = false;
      vm.invalidNumberOfSheets = false;
      vm.tooManyRows = false;

      sidebarMyOrderFactory.addressProcessing = true;

      recipientsFactory.setAddingAddresses('ongoing');
      vm.addressUploading = 'ongoing';

      recipientsFactory.setAddressFile(file.name);
      Common.set('recipients.file', recipientsFactory.getAddressFile());

      vm.readingFile = true;

      resetSessionStorage();


      recipientsFactory.checkAddressLimit(file, invalidFile, checkRecipients);
    }


    function uploadToS3 (file, response) {
      console.log('uploadToS3: ' + JSON.stringify(response));

      const config = {
        url: response.url,
        headers: {
          'Content-Type': file.type,
          'x-file-upload-header': 'file_upload'
        },
        method: 'PUT',
        data: file
      };

      const folderId = response.config.folder.split('/')[1];

      webSocketFactory.open(
        web2print.env.addressValidationSocketUrl,
        folderId,
        checkAddressValidity,
        errCheckAddressValidity
      );

      Upload.http(config).then(function (resp) {
        vm.addressUploading = 'done';
        vm.addressStatus = 'sending';

        vm.csvFolder = response.config.folder;
        vm.readingFile = false;

      }, function (response) {
        if (response.status > 0) {
          console.log('File upload error: ' + response.status + ', ' + response.data);
        }
        vm.readingFile = false;

        vm.addressUploading = 'done';
      }, function (evt) { });
    }

    function checkAddressValidity (message) {
      webSocketFactory.close(); // close socket connection once message received
      const data = JSON.parse(message.data);

      vm.doneValidating = true;
      vm.addressStatus = 'done';
      recipientsFactory.setAddingAddresses('done');
      sidebarMyOrderFactory.addressProcessing = false;
      vm.processing = false;

      if (data.noValidSheet) {
        vm.invalidNumberOfSheets = true;
        return;
      }

      vm.zoneCount = data.zoneCount;
      vm.countryCodes = Object.keys(data.countryCount);
      vm.showZoneCount = false;
      vm.tooManyRows = data.tooManyRows || false;
      checkZoneCount();

      recipientsFactory.setValidAddressCount(parseInt(data.validCount));
      recipientsFactory.setInvalidAddressCount(parseInt(data.invalidCount));
      vm.discountPostalCodeCount = parseInt(data.discountPostalCodeCount);
      vm.validColumns = !data.missingHeaders;

      vm.readingFile = false;
      vm.folderId = data.id;

      if (!parseInt(recipientsFactory.getValidAddressCount())
        && !parseInt(recipientsFactory.getInvalidAddressCount()) && parseInt(data.ignoredRows)) {
        vm.invalidFileFormat = true;
        return;
      }

      setToSessionStorage();
    }

    function errCheckAddressValidity (err) {
      console.log('failed address check...');
      recipientsFactory.setAddingAddresses('done');
      vm.addressStatus = 'done';
      vm.readingFile = false;
    }

    function resetSessionStorage () {
      Common.set('recipients.file', undefined);
      Common.set('recipients.validAddressCount', undefined);
      Common.set('recipients.invalidAddressCount', undefined);
      Common.set('recipients.zoneCount', undefined);
      Common.set('recipients.csvFolder', undefined);
      Common.set('address', undefined);
      Common.set('addressesFolderId', undefined);
      Common.set('originalAddressFileName', undefined);
      Common.set('uploadDateTime.addresses', undefined);
      Common.notifyObserver('web2print.pricing');
      Common.notifyObserver('updateSidePanelDetails');
      Common.notifyObserver('updateValidAddresses');
    }

    function removeAttachment () {
      // note: this still supports one file upload.

      recipientsFactory.setAddressFile(null);
      recipientsFactory.setValidAddressCount(0);
      recipientsFactory.setInvalidAddressCount(0);
      vm.addresses = [];
      vm.doneAddresses = false;

      recipientsFactory.setAddingAddresses('not_start');

      resetSessionStorage();

    }

    function truncateFileName (name) {
      const len = name.length;
      if (len < 24) {
        return name;
      }
      return name.slice(0, 10) + '...' + name.slice(len - 10, len);
    }

    function resetRecipientModel () {
      vm.recipientModel = {
        'firstName': '',
        'lastName': '',
        'co': '',
        'street': '',
        'city': '',
        'country': '',
        'countryCode': '',
        'zipCode': '',
        'email': '',
        'phoneNumber': '',
        'companyName': '',
        'attn': ''
      };

    }

    function resetFields () {
      vm.stringFields = {
        'firstName': true,
        'lastName': true,
        'companyName': true,
        'street': true,
        'city': true,
        'country': true,
        'zipCode': true,
        'countryCode': true,
        'attn': true
      };
    }

    function resetAll () {
      vm.resetRecipientModel();
      vm.resetFields();

      // default to private
      vm.recipientModel.type = 'private';
    }

    function cancelAdd () {
      vm.showAddForm = false;
      vm.resetAll();
    }

    function changeDownloadStatus () {
      vm.downloading = !vm.downloading;
    }

    function downloadInvalidAddressDetails () {
      changeDownloadStatus();
      FileDownload.getInvalidAddressDetails(0, 'information', changeDownloadStatus);
    }

    // Column name can also vary depending on the selected market
    function getNameSampleValue (key, row) {
      return row[key][vm.language];
    }

    activate();
  }
})();
